import _ from 'lodash';

/* @ngInject */
export default function RcuQueueClearModal($uibModalInstance, rcuArray, RcuManagementService, RcuQueueOptions) {
  const vm = this;
  vm.queueOptions = RcuQueueOptions;

  vm.submit = submit;
  vm.close = close;

  function submit() {
    const queuesToSend = [];
    _.forEach(vm.queueOptions, (queue) => {
      if (queue.selected) {
        _.forEach(rcuArray, (rcu) => {
          if (queue.queueType === 'normal') {
            queuesToSend.push({
              name: `downloadFromRcu-${rcu}`,
              state: queue.value
            });
          } else if (queue.queueType === 'long') {
            queuesToSend.push({
              name: `downloadFromRcuLong-${rcu}`,
              state: queue.value
            });
          }
        });
      }
    });
    RcuManagementService.clearQueues(queuesToSend);
    $uibModalInstance.dismiss('close');
  }

  function close() {
    $uibModalInstance.dismiss('close');
  }
}
